module.exports = __webpack_public_path__ + "img/downloadbanner.39100c09.png";